import { render } from "./Detailing.vue?vue&type=template&id=28a744d6&scoped=true"
import script from "./Detailing.vue?vue&type=script&lang=js"
export * from "./Detailing.vue?vue&type=script&lang=js"

import "./Detailing.vue?vue&type=style&index=0&id=28a744d6&scoped=true&lang=css"

import exportComponent from "C:\\Askar\\personalArea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28a744d6"]])

export default __exports__